async function initMapForElements() {
    //@ts-ignore
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
  
    const mapElements = document.querySelectorAll('.init-map');
  
    const fixedLocation = { lat: 38.506060, lng: -122.489790 }; // Fixed location for the map
  
    mapElements.forEach(mapElement => {
      const map = new Map(mapElement, {
        zoom: 13,
        center: fixedLocation,
        mapId: "SMV_Location",
      });
  
      const marker = new AdvancedMarkerElement({
        map: map,
        position: fixedLocation,
        title: "Fixed Location",
      });
    });
  }
  
  // Call the initMapForElements function to initialize maps for elements with class init-map
  initMapForElements();
  
  
  